import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CanaisServiceService } from '../canais/canais-service.service';
import { UserService } from '../services/user.service';
import { urlApi } from '../../../utils/apiConfig';


interface CreateNutricaoAttributes{
  nome: string;
}

interface ObjectMessageAttributes {
  message: string;
  unidademedida: string;
  time: string;
  buttons: string;
}


@Injectable()
export class NutricoesService {


  constructor(private http: HttpClient, private channelService: CanaisServiceService, private userService: UserService) {
    
   }

  public getAllNutricoes(): Observable<any> {
    return this.http.get(urlApi+'/app/nutritions');
  }

  public setNutricao(data: CreateNutricaoAttributes){
    return this.http.post(urlApi+'/app/nutritions', data);
  }

  public getNutricaoById(id: number): Observable<any> {
    return this.http.get(urlApi);
  }

  public addNutricaoManual(nutricao: any): Observable<any> {
    return this.http.post(urlApi+'/app/flow/nutrition', nutricao);
  }

  public addNutricaoFile(nutricao: any): Observable<any> {
    return this.http.post(urlApi+'/app/flow/nutrition/csv', nutricao);
  }

  public updateNutricao(id: number, updatedNutricao: any): Observable<any> {
    return this.http.get(urlApi);
  }

  public deleteNutricao(idNutricao: number): Observable<any> {
    return this.http.delete(urlApi+`/app/nutritions/${idNutricao}`);
  }

  public getCanais(): Observable<any>{
    return this.channelService.getCanais();
  }

  public getConfigsUser(): Observable<any>{
    return this.userService.getConfigUser();
  }

  public setMessageNutricao(objectMessage: ObjectMessageAttributes): Observable<any>{
    return this.http.post(`${urlApi}/app/nutritions/configuracoes`, objectMessage);
  }

  public getMessagesRegistredOnNutrition(idNutrition: number): Observable<any>{
    return this.http.get(urlApi+`/app/nutritions/configuracoes/${idNutrition}`);
  }

  public deleteMessageRegistredInNutrition(idMessage: number): Observable<any> {
    return this.http.delete(urlApi+`/app/nutritions/configuracoes/${idMessage}`)
  }

  public getRastreioNumbersInNutrition(idNutricao: number): Observable<any>{
    return this.http.get(urlApi+`/app/nutritions/${idNutricao}`);
  }

  public deleteNumberInNutrition(number: number): Observable<any> {
    return this.http.delete(`${urlApi}/app/nutritions/deletar/${number} `);
  }
  
}
